import { useState } from "react";
import Textbox from "carbon-react/esm/components/textbox";

import { formatFinancialAmount } from "./FinancialValue";

interface CurrencyTextboxProps {
  currency: string;
  label: string;
  onChange(value: string): void;
  required?: boolean;
  value: string;
}

export function CurrencyTextbox({ currency, label, onChange, required = false, value }: CurrencyTextboxProps) {
  const [focused, setFocused] = useState(false);
  const displayValue = focused || !value ? value : formatFinancialAmount(value, currency);

  return (
    <Textbox
      align="right"
      inputMode="decimal"
      label={label}
      onBlur={() => setFocused(false)}
      onChange={(event) => onChange(normalizeCurrencyInput(event.target.value))}
      onFocus={() => setFocused(true)}
      required={required}
      value={displayValue}
    />
  );
}

export function normalizeCurrencyInput(value: string): string {
  const sanitized = value.replace(/[^\d.]/gu, "");
  const [integer = "", ...fractions] = sanitized.split(".");
  return fractions.length === 0 ? integer : `${integer}.${fractions.join("").slice(0, 2)}`;
}